import React, { LegacyRef } from 'react';

import {
  getLogoTitle,
  getTelTitle,
  getTelNummber,
  getTelNummberLink,
  getHeaderInjection,
} from './overrides';

import './index.scss';
import { replaceAllComplex } from '../../../../../../mol_function';
import MolLink from '../Menu/MolLink';

import $ from 'jquery';

interface HeaderMolunaProps {
  domainPrefix: string;
  articleCount: number;
  articlePreis: string;
  isLogin: boolean;
  showSearch: boolean;
  subTitel: React.ReactFragment;
}

export default class HeaderMoluna extends React.Component<HeaderMolunaProps> {
  safeRef: LegacyRef<HTMLLIElement> | undefined;

  constructor(props: any) {
    super(props);
    this.safeRef = React.createRef();
  }

  componentDidMount() {
    let ref: any = this.safeRef;
    ref.current.style.visibility = 'collapse';
  }

  render() {
    return (
      <React.Fragment>
        <div id="headermoluna">
          <MolLink
            to="/"
            href={this.props.domainPrefix}
            inlineStyle={{ float: 'left' }}
          >
            <div id="logo" title={getLogoTitle()}></div>
          </MolLink>
          <div id="subheadermoluna">
            <div id="navMain">
              <ul>
                {this.props.subTitel}
                {getHeaderInjection()}
                <li className="safe" ref={this.safeRef}>
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 10,
                    }}
                  >
                    <img
                      src="favicon.ico"
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                </li>
                <li className="tel">
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=contact_us'
                    }
                    title={getTelTitle()}
                  ></a>
                  <a
                    href={
                      this.props.domainPrefix +
                      '/index.php?main_page=contact_us'
                    }
                  ></a>
                  <a href={getTelNummberLink()}>{getTelNummber()}</a>
                  <span className="mobilecontact">
                    <MolLink to="/kontakt" href="/kontakt" title="Kontakt">
                      persönlicher Kundenservice
                    </MolLink>
                  </span>
                </li>
                <li className="login">
                  {this.props.isLogin ? (
                    <>
                      <MolLink to="/konto" href="/konto" title="Konto">
                        <span style={{ color: 'transparent' }}>..</span>
                      </MolLink>
                      <MolLink to="/konto" href="/konto" title="Konto">
                        Konto
                      </MolLink>

                      <MolLink
                        to="/login?action=logout"
                        href="/login?action=logout"
                        title="Logout"
                      >
                        <span style={{ whiteSpace: 'nowrap' }}>✘ Abmelden</span>
                      </MolLink>
                    </>
                  ) : (
                    <>
                      <MolLink to="/login" href="/login" title="Login/Logout" />
                      <MolLink to="/login" href="/login" title="Login/Logout" />
                      <MolLink to="/login" href="/login" title="Login/Logout">
                        Anmelden
                      </MolLink>
                    </>
                  )}
                </li>
                <li>
                  <MolLink
                    to="/shopping_cart/"
                    href="/shopping_cart/"
                    title="Mein Warenkorb"
                  />
                </li>

                <li className="backet">
                  <span style={{ color: 'transparent' }}>{'....'}</span>
                  <MolLink
                    to="/shopping_cart/"
                    href="/shopping_cart/"
                    title={this.props.articleCount + ' Artikel'}
                  >
                    {this.props.articleCount} Artikel
                  </MolLink>{' '}
                  <span className="wk_wert">
                    <MolLink
                      to="/shopping_cart/"
                      href="/shopping_cart/"
                      title={this.props.articlePreis}
                    >
                      {this.props.articlePreis}
                    </MolLink>
                  </span>
                </li>
              </ul>
            </div>
            {this.props.showSearch ? (
              <div id="navMainSearch">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    let searchValue = $('#autosearch').val();
                    setTimeout(() => {
                      $('.ui-autocomplete.ui-menu').hide();
                      $('#autosearch').val('');
                      setTimeout(() => {
                        $('.ui-autocomplete.ui-menu').hide();
                      }, 1000);
                    }, 500);

                    let windowAny: any = window;

                    /*
                    searchValue = encodeURIComponent(searchValue) replaceAllComplex(, [
                      { s: ' ', r: '+' },
                      { s: '&', r: '%26' },
                    ]);
                    */
                    if (
                      searchValue != undefined &&
                      typeof searchValue === 'string'
                    ) {
                      searchValue = encodeURI(searchValue);

                      windowAny.historyHelper.memory.push(
                        '/search_page/?keyword=' + searchValue,
                        null,
                      );
                    }
                    return false;
                  }}
                >
                  <input
                    type="hidden"
                    name="main_page"
                    value="advanced_search_result"
                  ></input>
                  <input
                    type="hidden"
                    name="search_in_description"
                    value="1"
                  ></input>
                  <input
                    type="text"
                    name="keyword"
                    size={18}
                    maxLength={100}
                    className="search-header-box"
                    id="autosearch"
                    title="Suchbegriff oder ISBN Nr. (z.B. 978-3-551-55900-5) eingeben"
                    placeholder="Suchbegriff oder ISBN Nr.  eingeben"
                    defaultValue=""
                  ></input>
                  <input
                    style={{ display: 'none' }}
                    className="cssButton submit_button button  button_search"
                    type="submit"
                    value="Suche"
                    onMouseOver={(e) => {
                      let input: any = e.target;
                      if (input != null)
                        input.className =
                          'cssButtonHover  button_search button_searchHover';
                    }}
                    onMouseOut={(e) => {
                      let input: any = e.target;
                      if (input != null)
                        input.className =
                          'cssButton submit_button button  button_search';
                    }}
                  ></input>
                </form>
              </div>
            ) : null}{' '}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
